import { LaboratoryRequestItem } from '../Interfaces/LaboratoryRequestItem.intefrace';
import React from 'react';

export default function useLaboratoryRequestStyles(
	item: LaboratoryRequestItem,
) {
	const style: React.CSSProperties = {};

	if (item.settings?.flexDirection) {
		style.flexDirection = item.settings?.flexDirection;
	}

	if (item.settings?.backgroundColor) {
		style.backgroundColor = item.settings?.backgroundColor;
		style.padding = '10px';
	}

	if (item.settings?.background) {
		style.background = item.settings?.background;
		style.padding = '10px';
	}

	if (item.settings?.gap) {
		style.gap = item.settings?.gap;
	}

	if (item.settings?.minHeight) {
		style.minHeight = item.settings?.minHeight;
	}

	if (item.settings?.flex) {
		style.flex = item.settings.flex;
	}

	if (item.settings?.fontWeight) {
		style.fontWeight = item.settings.fontWeight;
	}

	if (item.settings?.color) {
		style.color = item.settings.color;
	}

	if (item.settings?.fontSize) {
		style.fontSize = item.settings.fontSize;
	}

	return style;
}
